module.exports = __webpack_public_path__ + "static/media/milex-pessaries-product@3x.0be01538.jpg";